import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { PromptuaryFillingInstructionsWarning } from './promptuary-filling-instructions-warning.component';

@NgModule({
	declarations: [PromptuaryFillingInstructionsWarning],
	imports: [CommonModule, TranslateModule.forChild()],
	exports: [PromptuaryFillingInstructionsWarning],
	providers: [],
})
export class PromptuaryFillingInstructionsWarningModule {}
